import { FC, useState } from "react";
import { Grid, useTheme } from "@mui/material";
import {
    ITest,
    LabelPosition,
    RHookFormMaskedTextFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { RHookFormMaskedTextFieldWithVerifyLabel } from "../../RHookFormMaskedTextFieldWithVerifyLabel";

interface IEmployeeBankSetupFieldsRightPanel extends ITest {
    isAdminUser: any;
    selectedSplit: number
    onVerifyBankClickedHandler: () => void;
}
export const EmployeeBankSetupFieldsRightPanel: FC<
    IEmployeeBankSetupFieldsRightPanel
> = ({ isAdminUser, selectedSplit, onVerifyBankClickedHandler }) => {
    // const [selectedSplit, setSelectedSplit] = useState(100);
    const theme = useTheme();
    return (
        <>
            <RHookFormTextFieldWithLabel
                id="account2Name"
                testId={`account-2-Name`}
                label="Bank Name"
                labelPosition={LabelPosition.Top}
            />
            {/* <RHookFormMaskedTextFieldWithLabel
                    id="account2No"
                    testId={`account2No`}
                    placeholder={"000000000000000000"}
                    inputMaskPattern={"000000000000000000"}
                    label="Bank Account No."
                    labelPosition={LabelPosition.Top}
    
                /> */}
            <RHookFormMaskedTextFieldWithVerifyLabel
                id="account2No"
                testId={`account2No`}
                placeholder={"000000000000000000"}
                inputMaskPattern={"000000000000000000"}
                label={
                    <>
                        <Grid> Bank Account No.&nbsp;
                            <span style={{ color: theme.palette.primary.light, cursor: "pointer" }} onClick={onVerifyBankClickedHandler}>
                                [Verify]
                            </span>
                        </Grid>
                    </>
                }
            />
            <RHookFormMaskedTextFieldWithLabel
                id="branchTransitNoAccount2"
                testId={`branch-Transit-Number-For-Account-2`}
                inputMaskPattern="00000"
                placeholder="5 Digits"
                label="Branch / Transit No."
            />
            <RHookFormMaskedTextFieldWithLabel
                id="bankFinancialNoAccount2"
                testId={`branch-Finacial-Number-For-Account-2`}
                inputMaskPattern={"0000"}
                placeholder={"4 Digits"}
                label="Bank / Fin Institution No."
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                label="% / $ in Account 1"
                id="percenagePerDollorInAcc1"
                testId={`% / $-in-Account-1`}
                labelPosition={LabelPosition.Top}
                labelColumns={4.1}
                fieldColumns={7.9}
                readOnly={selectedSplit === 200}
            />
        </>
    );
};
